<template>
    <div>
        <van-nav-bar
            title="联系我们"
            left-text="返回"
            left-arrow
            @click-left="$router.push({path:'/',query:{...$route.query}})"
        />
        <div class="text-center margin-top-70">
            <img src="/images/logo.png" height="60"/>
        </div>
        <div class="margin-top-70" v-if="setting">
            <van-cell-group>
                <van-cell title="客服热线" :value="setting.service_tel" is-link @click="callphone(setting.service_tel)"/>
                <van-cell title="会员咨询1" :value="setting.vip_tel" is-link @click="callphone(setting.vip_tel)"/>
                <van-cell title="会员咨询2" :value="setting.vip_weixin_tel+'(同微信号)'" @click="callphone(setting.vip_weixin_tel)" is-link/>
                <van-cell title="招标发布" :value="setting.bids_push_tel" is-link @click="callphone(setting.bids_push_tel)"/>
                <van-cell title="售后咨询" :value="'QQ：'+setting.service_qq" @click="copy(setting.service_qq)" is-link/>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
export default {
    name: "about",
    data(){
        return{
            setting:{
                service_tel:'',
                vip_tel:'',
                bids_push_tel:'',
                service_qq:'',
                vip_weixin_tel:''
            }
        }
    },
    mounted() {
        this.getDetail();
    },
    methods:{
        getDetail() {
            let _this = this;
            let _skeys = [];

            for (let k in this.setting) {
                _skeys.push(k);
            }

            this.$http.post({
                url:'/SystemSetting/getSystem',
                data:{skey: _skeys},
                success(res){
                    console.log(res);
                    _this.setting = res;
                }
            })
        },
        callphone(phone){
            window.location.href = 'tel://'+phone
        },
        copy(qq){
            let _this = this;
            this.$copyText(qq).then(function (e) {
                _this.$toast('复制成功');
            }, function (e) {

            })
        }
    }
}
</script>
